import { render, staticRenderFns } from "./EditSVG.vue?vue&type=template&id=08ee7886&scoped=true"
import script from "./EditSVG.vue?vue&type=script&lang=js"
export * from "./EditSVG.vue?vue&type=script&lang=js"
import style0 from "./EditSVG.vue?vue&type=style&index=0&id=08ee7886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee7886",
  null
  
)

export default component.exports